import { useTranslations } from 'next-intl';
import { ManufacturerAdditionalContentsValue } from '@headless-workspace/domain/common/server';
import { GlowTextBody, PropsWithFontFamily } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';

type ProductManufacturerDescriptionProps = PropsWithFontFamily & {
    info: ManufacturerAdditionalContentsValue['value'];
    sku?: string;
};

export const ProductManufacturerDescription: Component<ProductManufacturerDescriptionProps> = ({
    info,
    sku,
    fontFamily,
}) => {
    const t = useTranslations('Discover.Pdp.productInfo.productTab');

    return (
        <div className={'flex flex-col gap-1.25'}>
            <div className={'flex gap-0.25'}>
                <GlowTextBody fontFamily={fontFamily} fontWeight={'bold'} text={`${t('label.productCode')}: `} />
                <GlowTextBody fontFamily={fontFamily} text={sku} />
            </div>
            <div>
                <GlowTextBody fontFamily={fontFamily} fontWeight={'bold'} text={t('label.manufacturerResponsibleEU')} />
                <GlowTextBody fontFamily={fontFamily} text={info?.contact?.name} />
                <GlowTextBody fontFamily={fontFamily} text={info?.contact?.address} />
                <GlowTextBody fontFamily={fontFamily} text={info?.contact?.email} />
            </div>
            <div>
                <GlowTextBody fontFamily={fontFamily} fontWeight={'bold'} text={t('label.manufacturerContact')} />
                <GlowTextBody fontFamily={fontFamily} text={info?.name} />
                <GlowTextBody fontFamily={fontFamily} text={info?.address} />
                <GlowTextBody fontFamily={fontFamily} text={info?.email} />
            </div>
        </div>
    );
};
